import { render, staticRenderFns } from "./CustomViewer.vue?vue&type=template&id=bea04f9a&"
import script from "./CustomViewer.vue?vue&type=script&lang=js&"
export * from "./CustomViewer.vue?vue&type=script&lang=js&"
import style0 from "./CustomViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports